import { useCallback } from 'react';

import {
  boardSwitcherSearchSharedState,
  boardSwitcherSharedState,
} from '@trello/board-switcher';
import { useFeatureGate } from '@trello/feature-gate-client';
import { useSharedStateSelector } from '@trello/shared-state';
import { useOpenBoardPanel } from '@trello/split-screen';

export const useOpenBoardAndHideSwitcher = () => {
  const openBoardPanel = useOpenBoardPanel();

  const { value: isBoardSwitcherPanelEnabled } = useFeatureGate(
    'billplat_board_switcher_panel',
  );
  const mode = useSharedStateSelector(
    boardSwitcherSharedState,
    (state) => state.mode,
  );

  return useCallback(() => {
    if (isBoardSwitcherPanelEnabled && mode === 'panel') return;

    openBoardPanel();
    boardSwitcherSharedState.setValue({
      isOpen: false,
    });
    boardSwitcherSearchSharedState.setValue({
      query: null,
    });
  }, [isBoardSwitcherPanelEnabled, mode, openBoardPanel]);
};
